import type {ReactElement} from 'react'

import {DockedPanel} from '../../contexts/DockedPanelContext'

import {AlertsSidePanel} from './AlertsSidePanel'
import {CommentsSidePanel} from './CommentsSidePanel'
import {CopilotChatSidePanel} from './CopilotChatSidePanel'
import {ManageBatchPanel} from './ManageBatchPanel'
import {MergeStatusPanel} from './MergeStatusPanel'
import {OverviewTimelinePanel} from './OverviewTimelinePanel'
import {OverviewSidePanel} from './OverviewSidePanel'

/**
 * Maps each docked panel id to the component that renders its body.
 *
 * Kept in a separate module from `panel-registry.tsx` so that consumers of
 * panel metadata do not transitively import every panel's module graph.
 *
 * Note: the Comments panel has a flag-off carve-out — when
 * `updated_pull_request_header` is OFF the panel is rendered as a child of
 * `OpenCommentsPanelButton` (so it inherits `PullRequestStoreProvider`
 * scope) and portals into the docked panel target. `DockedSidePanelContent`
 * suppresses the render-map render of Comments under that flag to avoid
 * double-mounting.
 */
export function renderActivePanel(id: DockedPanel): ReactElement | null {
  switch (id) {
    case DockedPanel.Alerts:
      return <AlertsSidePanel />
    case DockedPanel.Comments:
      return <CommentsSidePanel />
    case DockedPanel.CopilotChat:
      return <CopilotChatSidePanel />
    case DockedPanel.MergeStatus:
      return <MergeStatusPanel />
    case DockedPanel.Overview:
      return <OverviewSidePanel />
    case DockedPanel.Timeline:
      return <OverviewTimelinePanel />
    case DockedPanel.ManageBatchReviewComments:
      return <ManageBatchPanel />
  }
}
